import * as React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import PageLayout from 'v2/layout/PageLayout/PageLayout';
import NotFound from 'v2/pages/GeneralErrors/NotFound';
import AccessCardsOverview from './AccessCards/Overview';

const Cards: React.FC<React.PropsWithChildren> = () => (
  <PageLayout>
    <Routes>
      <Route path="/access-cards" element={<AccessCardsOverview />} />
      <Route path="/" element={<Navigate to="access-cards" replace />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </PageLayout>
);

export default Cards;
